import { render, staticRenderFns } from "./CloudBackup.vue?vue&type=template&id=512089c7&scoped=true&"
import script from "./CloudBackup.ts?vue&type=script&lang=ts&"
export * from "./CloudBackup.ts?vue&type=script&lang=ts&"
import style0 from "./CloudBackup.vue?vue&type=style&index=0&id=512089c7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512089c7",
  null
  
)

export default component.exports